import React, { useContext, Fragment } from 'react'
import { Typography, Select, MenuItem } from '@material-ui/core'
import { DailyMonitoringDetailsFiltersContext } from '../../../../context/DailyMonitoringDetailsFiltersContext'

export default function Month (): JSX.Element {
  const { filters, setFilters } = useContext(DailyMonitoringDetailsFiltersContext)

  const months: Array<number> = []
  for (let month = 1; month <= 12; month++) {
    months.push(month)
  }

  const handleChange = (event: any, value: any) => {
    setFilters({
      ...filters,
      date: {
        year: filters.date.year,
        month: +value.props.value,
        time_zone: filters.date.time_zone
      }
    })
  }

  return (
    <Fragment>
      <Typography id="discrete-slider-custom" gutterBottom>Mês</Typography>
      <Select
          labelId="daily-monitoring-month-filter-label"
          id="daily-monitoring-month-filter"
          value={filters.date.month}
          onChange={handleChange}
        >
          {months.map((month: number) => <MenuItem key={month} value={month}>{month}</MenuItem>)}
        </Select>
    </Fragment>
  )
}
